import { useTranslation } from 'react-i18next'
import { ThumbsDown, ThumbsUp } from 'lucide-react'
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/radio-group'
import { Label } from '@/components/shadcn/label'
import { EvaluationThumbsAnswer } from '@/api/model'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

// The default answer is nullable; `none` is a UI-only sentinel that clears the property.
const NONE = 'none'

export function DefaultThumbsAnswerEditor(props: PropertyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  return (
    <RadioGroup
      value={(props.value as string) ?? NONE}
      onValueChange={v => props.onChanged(v === NONE ? undefined : v)}
    >
      <Label className="flex items-center gap-2 font-normal">
        <RadioGroupItem value={NONE} />
        {t('subtypes.evaluationThumbs.defaultThumbsAnswerNone')}
      </Label>
      <Label className="flex items-center gap-2 font-normal">
        <RadioGroupItem value={EvaluationThumbsAnswer.ThumbsUp} />
        <ThumbsUp className="size-4" />
        {t('subtypes.evaluationThumbs.defaultThumbsAnswerUp')}
      </Label>
      <Label className="flex items-center gap-2 font-normal">
        <RadioGroupItem value={EvaluationThumbsAnswer.ThumbsDown} />
        <ThumbsDown className="size-4" />
        {t('subtypes.evaluationThumbs.defaultThumbsAnswerDown')}
      </Label>
    </RadioGroup>
  )
}
